const  main = {
    title: 'Hello I’m hichem ',
    subTitle: 'Full Stack developer',
    intro: 'I love helping people and programming is a my way to do that',
    subIntro: "how can I help you?"
  }

  export default main